// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3_nZ9","modalForm":"UpgradeEpcsModal_modalForm__mySEc","modalFooter":"UpgradeEpcsModal_modalFooter__Le8rS"};